var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDeveloper)?_c(_vm.DeveloperComponent,{tag:"component"}):_c(_vm.DefaultComponent,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }